<template>
  <div id="NewAdminUserForm">
    <form action>
      <div class="modal-card fixed-width dtac-font">
        <header class="modal-card-head">
          <p class="modal-card-title">
            {{ $t("users.form_create_user.title") }}
          </p>
        </header>
        <section class="modal-card-body">
          <div class="media">
            <div class="media-content">
              <p class="subtitle is-6">
                {{ $t("users.form_create_user.info") }}
              </p>
              <b-field>
                <b-input
                  type="textarea"
                  v-model="userLan"
                  custom-class="dtac-font"
                  :has-counter="false"
                  :placeholder="$t('users.form_create_user.info_username')"
                  required
                />
              </b-field>
              <p
                class="subtitle is-6"
                style="margin-top: 1.5rem; margin-bottom: 1rem;"
              >
                {{ $t("users.form_create_user.channel") }}
              </p>
              <b-field>
                <b-input
                  v-model="selectedChannel"
                  custom-class="dtac-font"
                  :placeholder="
                    $t('users.form_create_user.channel_placeholder')
                  "
                  expanded
                ></b-input>
              </b-field>
              <div class="container">
                <p class="subtitle is-6" style="margin-top: 1.5rem;">
                  {{ $t("users.form_create_user.info_roles") }}
                </p>
                <div class="columns is-multiline">
                  <!-- Checkbox: Report-->
                  <div class="column is-4">
                    <div class="field">
                      <b-checkbox v-model="isReport">{{
                        $t("users.table_details.report")
                      }}</b-checkbox>
                    </div>
                  </div>
                  <!-- Checkbox: Map Area -->
                  <div class="column is-4">
                    <div class="field">
                      <b-checkbox v-model="isMapArea">{{
                        $t("users.table_details.map_area")
                      }}</b-checkbox>
                    </div>
                  </div>
                  <!-- Checkbox: Manage User -->
                  <div class="column is-4">
                    <div class="field">
                      <b-checkbox v-model="isUserManage">{{
                        $t("users.table_details.user_manage")
                      }}</b-checkbox>
                    </div>
                  </div>
                  <!-- Checkbox: Register Customer -->
                  <div class="column is-4">
                    <div class="field">
                      <b-checkbox v-model="isCustomerRegister">{{
                        $t("users.table_details.customer_register")
                      }}</b-checkbox>
                    </div>
                  </div>
                  <!-- Checkbox: Get Customers-->
                  <div class="column is-4">
                    <div class="field">
                      <b-checkbox v-model="isCustomerList">{{
                        $t("users.table_details.customer_list")
                      }}</b-checkbox>
                    </div>
                  </div>
                  <!-- Checkbox: Update Customers -->
                  <div class="column is-4">
                    <div class="field">
                      <b-checkbox v-model="isCustomerUpdate">{{
                        $t("users.table_details.customer_update")
                      }}</b-checkbox>
                    </div>
                  </div>
                  <!-- Checkbox: Update Distance-->
                  <div class="column is-4">
                    <div class="field">
                      <b-checkbox v-model="isCustomerDistance">{{
                        $t("users.table_details.customer_distance")
                      }}</b-checkbox>
                    </div>
                  </div>
                  <!-- Checkbox: Get Prospect Customers -->
                  <div class="column is-4">
                    <div class="field">
                      <b-checkbox v-model="isCustomerProspect">{{
                        $t("users.table_details.customer_propect")
                      }}</b-checkbox>
                    </div>
                  </div>

                  <!-- Checkbox: Update Prospect Customers -->
                  <div class="column is-4">
                    <div class="field">
                      <b-checkbox v-model="isCustomerProspectUpdate">{{
                        $t("users.table_details.customer_prospect_update")
                      }}</b-checkbox>
                    </div>
                  </div>
                  <!-- Checkbox: Get Devices -->
                  <div class="column is-4">
                    <div class="field">
                      <b-checkbox v-model="isDeviceList">{{
                        $t("users.table_details.device_list")
                      }}</b-checkbox>
                    </div>
                  </div>
                  <!-- Checkbox: Update Devices -->
                  <div class="column is-4">
                    <div class="field">
                      <b-checkbox v-model="isDeviceUpdate">{{
                        $t("users.table_details.device_update")
                      }}</b-checkbox>
                    </div>
                  </div>
                  <!-- Checkbox: Bypass OTP -->
                  <div class="column is-4">
                    <div class="field">
                      <b-checkbox v-model="isBypassOTP">{{
                        $t("users.table_details.bypass_otp")
                      }}</b-checkbox>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <footer class="modal-card-foot" style="justify-content: flex-end;">
          <button class="button dtac-font" @click.prevent="$emit('close')">
            {{ $t("register.form.otp.close_btn") }}
          </button>
          <button
            class="button is-primary dtac-font"
            @click.prevent="confirmCreateNewUserPress"
          >
            {{ $t("register.form.otp.confirm_btn") }}
          </button>
        </footer>
      </div>
    </form>
  </div>
</template>

<script>
import AlertManager from "@/managers/AlertManager";
import UserApiManager from "@/apis/UserApiManager";

export default {
  name: "NewAdminUserForm",
  data() {
    return {
      userLan: null,
      isReport: false,
      isMapArea: false,
      isUserManage: false,
      isCustomerRegister: false,
      isCustomerList: false,
      isCustomerUpdate: false,
      isCustomerDistance: false,
      isCustomerProspect: false,
      isCustomerProspectUpdate: false,
      isDeviceList: false,
      isDeviceUpdate: false,
      isBypassOTP: false,
      channels: ["Van", "Team"],
      selectedChannel: null
    };
  },
  methods: {
    confirmCreateNewUserPress: function() {
      if (this.userLan && this.userLan != "") {
        const roles = {
          report: this.isReport,
          map_area: this.isMapArea,
          device_list: this.isDeviceList,
          device_update: this.isDeviceUpdate,
          user_manage: this.isUserManage,
          customer_list: this.isCustomerList,
          customer_update: this.isCustomerUpdate,
          customer_register: this.isCustomerRegister,
          customer_propect: this.isCustomerProspect,
          customer_prospect_update: this.isCustomerProspectUpdate,
          customer_distance: this.isCustomerDistance,
          bypass_otp: this.isBypassOTP
        };
        // Remove all space occured in the input text
        let nospaceString = this.userLan.replace(/ /g, "");
        // Split by newline which each will contains device info "msisdn,imei,esn"
        const userLanList = nospaceString.split("\n");
        const params = {
          lan: userLanList,
          channel: this.selectedChannel,
          roles
        };
        this.createNewUser(params);
      } else {
        AlertManager.showErrorSnackbar(this.$t("alert.user_lan"));
      }
    },
    createNewUser: async function(params) {
      const loadingComponent = this.$buefy.loading.open({
        container: null
      });
      const createNewUserResult = await UserApiManager.requestCreateNewUser(
        params
      );
      loadingComponent.close();
      switch (createNewUserResult.code) {
        case "0":
          AlertManager.showSuccessSnackbar(this.$t("alert.new_user_lan"));
          this.$emit("completed_create_new_user", createNewUserResult.data);
          break;

        default:
          this.$buefy.dialog.alert({
            title: "Add New User Error",
            message: createNewUserResult.message,
            type: "is-danger",
            hasIcon: true
          });
          break;
      }
      this.$emit("close");
    }
  }
};
</script>

<style scoped>
.fixed-width {
  max-width: 680px;
  padding: 0 20px;
}
</style>
